'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _treatProduct = require('./treat-product.component');

var _treatProduct2 = _interopRequireDefault(_treatProduct);

var _copy = require('./copy/copy.module');

var _copy2 = _interopRequireDefault(_copy);

var _treatInformation = require('./information/treat-information.module');

var _treatInformation2 = _interopRequireDefault(_treatInformation);

var _treatAdminForm = require('./treat-admin-form/treat-admin-form.module');

var _treatAdminForm2 = _interopRequireDefault(_treatAdminForm);

var _treatAdminList = require('./treat-admin-list/treat-admin-list.module');

var _treatAdminList2 = _interopRequireDefault(_treatAdminList);

var _ingredientForm = require('./ingredient-form/ingredient-form.module');

var _ingredientForm2 = _interopRequireDefault(_ingredientForm);

var _ingredientList = require('./ingredient-list/ingredient-list.module');

var _ingredientList2 = _interopRequireDefault(_ingredientList);

var _signOff = require('./sign-off/sign-off.module');

var _signOff2 = _interopRequireDefault(_signOff);

var _usageData = require('./usage-data/usage-data.module');

var _usageData2 = _interopRequireDefault(_usageData);

require('./product.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.treatProduct', [_angularUiRouter2.default, _copy2.default, _treatInformation2.default, _treatAdminForm2.default, _treatAdminList2.default, _ingredientForm2.default, _ingredientList2.default, _signOff2.default, _usageData2.default]).component('treatProduct', _treatProduct2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('treatProductEdit', {
    parent: 'app',
    url: '/products/treat/{id:int}',
    component: 'treatProduct',
    resolve: {
      product: function product($stateParams, ProductService) {
        return ProductService.getProduct($stateParams.id).then(function (r) {
          return r.data;
        });
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      // TODO: Refactor to OData call
      frequencies: function frequencies(ProductService) {
        return ProductService.getFrequencies().then(function (r) {
          return r.data.map(function (f) {
            var obj = {};
            obj.Name = f.Name;
            obj.Value = +f.Value;
            return obj;
          });
        });
      },
      administrationUnits: function administrationUnits(ProductService) {
        return ProductService.getAdministrationUnitsForTreats().then(function (r) {
          return r.data;
        });
      },
      weightUnits: function weightUnits(ProductService) {
        return ProductService.getWeightUnits().then(function (r) {
          return r.data;
        });
      }
    }
  }).state('treatProductCreate', {
    parent: 'app',
    url: '/products/createTreat',
    component: 'treatProduct',
    resolve: {
      product: function product(currentUser) {
        return {
          ProductId: 0,
          MemberId: currentUser.MemberId,
          IsTreat: 1,
          ProductForm: 'Treat(s)'
        };
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      // TODO: Refactor to OData call
      frequencies: function frequencies(ProductService) {
        return ProductService.getFrequencies().then(function (r) {
          return r.data.map(function (f) {
            var obj = {};
            obj.Name = f.Name;
            obj.Value = +f.Value;
            return obj;
          });
        });
      },
      administrationUnits: function administrationUnits(ProductService) {
        return ProductService.getAdministrationUnitsForTreats().then(function (r) {
          return r.data;
        });
      },
      weightUnits: function weightUnits(ProductService) {
        return ProductService.getWeightUnits().then(function (r) {
          return r.data;
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/product/treat-product.module.js